var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    role: "img",
    width: 36,
    height: 36,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3b7bd7",
    d: "M 12,20 C 7.59,20 4,16.41 4,12 4,7.59 7.59,4 12,4 c 4.41,0 8,3.59 8,8 0,4.41 -3.59,8 -8,8 M 12,2 C 6.4771525,2 2,6.4771525 2,12 2,17.522847 6.4771525,22 12,22 17.522847,22 22,17.522847 22,12 22,6.4771525 17.522847,2 12,2 M 8.6666667,16.5 14.666667,12 8.6666667,7.5 Z",
    id: "path10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b7bd7",
    d: "M 13.343719,7.5131454 13.332033,16.47517",
    id: "path279"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b7bd7",
    d: "m 13.330729,7.5 h 2 v 8.994792 h -2 z",
    id: "path341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.336993276f15c6689177f4deda1b1084.svg";
export { ForwardRef as ReactComponent };